const Footer = () => {
  return (
    <div className="wrapper">
      <div className="wrap2 setin">
        <div className="footer">
          <div className="social_media">
            <a href="https://www.facebook.com/" className="btn_fb" />
            <a href="https://instagram.com/" className="btn_ig" />
            <a href="https://youtube.com/" className="btn_youtube" />
          </div>
          <div className="copyright">
            © 2022 Copyright  灼見運動數據有限公司
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer